import React from 'react';
import { Box, Flex } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { useIntl } from '@atlassian/jira-intl';
import {
	PeriscopeInsightsSkeleton,
	PeriscopeSuggestionsSkeleton,
	PeriscopeWorkItemsSkeleton,
	DevelopmentPageWorkItemsVulnTabSkeleton,
	DevelopmentPageWorkItemsDeploymentTabSkeleton,
} from '@atlassian/jira-skeletons/src/ui/periscope-page/PeriscopeSuggestionsSkeleton.tsx';
import messages from './messages.tsx';

const styles = cssMap({
	mainContainer: {
		width: '100%',
		height: '100%',
		display: 'flex',
		boxSizing: 'border-box',
		overflow: 'hidden',
	},
	leftColumn: {
		flex: '2 1 0',
	},
	rightColumn: {
		flex: '1 1 0',
	},
	suggestionsContainer: {
		width: '100%',
		overflow: 'hidden',
		height: '650px',
		boxSizing: 'border-box',
	},
	insightsContainer: {
		overflow: 'hidden',
		width: '100%',
		height: '385px',
		boxSizing: 'border-box',
	},
	workItemsContainer: {
		width: '100%',
		height: '600px',
		boxSizing: 'border-box',
		overflow: 'hidden',
	},
	workItemsVulnTabContainer: {
		width: '100%',
		height: '420px',
		boxSizing: 'border-box',
		overflow: 'hidden',
	},
});

// Extend this for loading screen
export const Skeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Flex
			xcss={styles.mainContainer}
			data-testId="software-periscope-periscope-page.ui.loading"
			aria-label={formatMessage(messages.label)}
			gap="space.300"
		>
			<Flex xcss={styles.leftColumn} direction="column">
				<Box xcss={styles.insightsContainer}>
					<PeriscopeInsightsSkeleton />
				</Box>
				<Box xcss={styles.workItemsContainer}>
					<PeriscopeWorkItemsSkeleton />
				</Box>
			</Flex>
			<Flex xcss={styles.rightColumn}>
				<Box xcss={styles.suggestionsContainer}>
					<PeriscopeSuggestionsSkeleton />
				</Box>
			</Flex>
		</Flex>
	);
};

export const InsightsSkeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Box
			xcss={styles.insightsContainer}
			data-testId="software-periscope-periscope-page.insights-ui.loading"
			aria-label={formatMessage(messages.insightsLabel)}
			paddingBlockEnd="space.400"
		>
			<PeriscopeInsightsSkeleton />
		</Box>
	);
};

export const SuggestionsSkeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Box
			xcss={styles.suggestionsContainer}
			data-testId="software-periscope-periscope-page.suggestions-ui.loading"
			aria-label={formatMessage(messages.suggestionsLabel)}
			paddingBlockEnd="space.400"
		>
			<PeriscopeSuggestionsSkeleton />
		</Box>
	);
};

// Extend this for loading screen
export const WorkItemsSkeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Box
			xcss={styles.workItemsContainer}
			aria-label={formatMessage(messages.workItemsLabel)}
			paddingBlockEnd="space.400"
		>
			<PeriscopeWorkItemsSkeleton />
		</Box>
	);
};

export const WorkItemsVulnTabSkeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Box
			xcss={styles.workItemsVulnTabContainer}
			aria-label={formatMessage(messages.workItemsVulnTabLabel)}
		>
			<DevelopmentPageWorkItemsVulnTabSkeleton />
		</Box>
	);
};

export const WorkItemsDeploymentTabSkeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Box
			xcss={styles.workItemsContainer}
			aria-label={formatMessage(messages.workItemsDeploymentTabLabel)}
			paddingBlockEnd="space.400"
		>
			<DevelopmentPageWorkItemsDeploymentTabSkeleton />
		</Box>
	);
};
